<template>
  <div>
    <el-table :data="userList" height="900" size="mini">
      <el-table-column prop="id" width="100px" label="用户ID" fixed>
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{ scope.row.id }}</span>
          <span v-else>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="VIP等级" width="90" align="center" fixed="left">
        <template slot-scope="scope">VIP{{ scope.row.vipLevel || 0 }}</template>
      </el-table-column>
      <el-table-column label="VIP到期时间" width="170" fixed="left">
        <template slot-scope="scope">{{ formatVipTime(scope.row.vipExpireTime) }}</template>
      </el-table-column>
      <el-table-column prop="channelUserId" label="合伙人UID" align="center" width="120" fixed="left" />
      <el-table-column prop="topUserId" label="顶级合伙人UID" align="center" width="120" fixed="left">
        <template slot-scope="scope">
          <span>{{ scope.row.topUserId || '' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="inviteBy" label="邀请人" align="center" width="120" fixed="left" />
      <el-table-column label="备注" align="center" width="180">
        <template slot-scope="scope">
          <span
            class="remark-edit"
            :title="scope.row.tenantAdminRemark || ''"
            @click="openRemarkDialog(scope.row)"
          >
            {{ scope.row.tenantAdminRemark || '' }}
            <i class="el-icon-edit"></i>
          </span>
        </template>
      </el-table-column>

      <el-table-column width="160px" label="注册时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | moment }}
          <!-- {{timestampToTime(new Date(scope.row.createTime).getTime()) }} -->
        </template>
      </el-table-column>
      <el-table-column width="100px" prop="__registerFrom" label="注册来源">
        <template slot-scope="scope">
          <!-- <span v-if="scope.row.mark" class="red">{{
            scope.row.__registerFrom
          }}</span>
          <span v-else>{{ scope.row.__registerFrom }}</span> -->
          <span>{{ scope.row.__registerFrom }}</span>
        </template></el-table-column>

      <!-- <el-table-column prop="username" label="账号" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{
            scope.row.username
          }}</span>
          <span v-else>{{ scope.row.username }}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="tel" label="电话" width="120"></el-table-column>
      <el-table-column prop="email" label="邮箱" width="120"></el-table-column>
      <el-table-column prop="inviteBy" label="推荐人ID"></el-table-column>
      <el-table-column prop="discountRate" label="用户折扣">
        <template slot-scope="scope">
          <span v-if="$hasPerm('tenant:user_info:discount_rate')" @click="openDiscountRate(scope.row)"
            class="discountRate">
            {{ scope.row.discountRate }}
          </span>
          <span v-else>{{ scope.row.discountRate }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" label="异常账号">
        <template slot-scope="scope">
          <el-switch :value="scope.row.mark" :disabled="!$hasPerm('tenant:user_info:mark_status')"
            @change="handleUpdateMarkStatus(scope.row.id, $event, 'mark')" active-color="#13ce66"></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="140" label="合伙人后台是否可登录">
        <template slot-scope="scope">
          <el-switch :value="scope.row.canLogin" :disabled="!$hasPerm('tenant:user_info:can_login')"
            @change="handleUpdateCanLogin(scope.row.id, $event)" active-color="#13ce66"></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="140" label="返佣风控开关">
        <template slot-scope="scope">
          <el-switch :value="!!scope.row.rebateFlag"
            :disabled="!$hasPerm('tenant:user_info:rebate_risk_switch')"
            @change="handleUpdateRebateRiskSwitch(scope.row.userId, $event)"
            active-color="#13ce66"></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="120" label="现货是否可交易">
        <template slot-scope="scope">
          <el-switch :value="scope.row.spotTrade" :disabled="!$hasPerm('tenant:user_info:spot_trade')" @change="
            handleUpdateMarkStatus(scope.row.userId, $event, 'spotTrade')
            " active-color="#13ce66"></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="120" label="合约是否可交易">
        <template slot-scope="scope">
          <el-switch :value="scope.row.allowTrade" :disabled="!$hasPerm('tenant:user_info:allow_trade')" @change="
            handleUpdateMarkStatus(scope.row.userId, $event, 'allowTrade')
            " active-color="#13ce66"></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="120" label="合约是否可开仓">
        <template slot-scope="scope">
          <el-switch :value="scope.row.allowOpenPosition" :disabled="!$hasPerm('tenant:user_info:allow_open_position')"
            @change="
              handleUpdateMarkStatus(
                scope.row.userId,
                $event,
                'allowOpenPosition'
              )
              " active-color="#13ce66"></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="120" label="合约是否可平仓">
        <template slot-scope="scope">
          <el-switch :value="scope.row.allowClosePosition"
            :disabled="!$hasPerm('tenant:user_info:allow_close_position')" @change="
              handleUpdateMarkStatus(
                scope.row.userId,
                $event,
                'allowClosePosition'
              )
              " active-color="#13ce66"></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="100px" label="用户状态">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.__userStatus && scope.row.__userStatus.color">{{ scope.row.__userStatus
            && scope.row.__userStatus.text }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100px" label="实名认证">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.idNoStatus !== 1" size="mini"
            :type="scope.row.__userStatus && scope.row.__idNoStatus.color">{{ scope.row.__userStatus &&
              scope.row.__idNoStatus.text }}</el-tag>
          <span v-if="scope.row.idNoStatus === 1">
            <div>{{ scope.row.idNo }}</div>
            <div>{{ scope.row.realName }}</div>
          </span>
        </template>
      </el-table-column>

      <el-table-column width="100px" label="高级认证">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.kycLevel == 1" size="mini" type="success">初级认证</el-tag>
          <el-tag v-if="scope.row.kycLevel == 2" size="mini" type="warning">高级认证</el-tag>
          <el-tag v-if="scope.row.kycLevel == 0" size="mini" type="info">未认证</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100px" label="邮箱认证">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.__emailSecurityStatus &&
            scope.row.__emailSecurityStatus.color
            ">
            {{
              scope.row.__emailSecurityStatus &&
              scope.row.__emailSecurityStatus.text
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100px" label="手机认证">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.__phoneSecurityStatus &&
            scope.row.__phoneSecurityStatus.color
            ">
            {{
              scope.row.__phoneSecurityStatus &&
              scope.row.__phoneSecurityStatus.text
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="110px" label="Google认证">
        <template slot-scope="scope">
          <el-button type="primary" v-if="scope.row.googleSecurityStatus"
            v-show="$hasPerm('tenant:user_info:cancel_google_auth')" size="mini"
            @click="cancelGoo(scope.row.id)">取消认证</el-button>
          <el-tag size="mini" v-else>未认证</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column
      width="120px"
      label="银行卡绑定状态">
      <template slot-scope="scope">
        <el-tag
          size="mini"
          :type="scope.row.__bankAuthStatus && scope.row.__bankAuthStatus.color"
        >
          {{scope.row.__bankAuthStatus && scope.row.__bankAuthStatus.text}}
        </el-tag>
      </template>
      </el-table-column>-->
      <el-table-column width="120px" label="是否迁移用户">
        <template slot-scope="scope">
          <el-tag size="mini" v-if="scope.row.oldOrNew === 'old'" type="success">是</el-tag>
          <el-tag size="mini" v-else :type="scope.row.__userVolunteerStatus &&
            scope.row.__userVolunteerStatus.color
            ">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="用户类型" width="110">
        <template slot-scope="scope">
          <a
            v-if="scope.row.userType == 2 && $hasPerm('tenant:user_info:update_user_type')"
            @click="handleUserType(scope.row)"
          >
            {{ userTypes[scope.row.userType] || userTypes['2'] }}
            <i class="el-icon-edit"></i>
          </a>
          <span v-else>
            {{ userTypes[scope.row.userType] || scope.row.userType }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column width="120" label="股东分红点亮状态">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.userDividendStatus"
            @change="handleUpdateDividendStatus(scope.row.id, $event)"
            active-color="#13ce66"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="设置节点">
        <template slot-scope="scope">
          <span v-if="!scope.row.node">否</span>
          <span v-else>是</span>
        </template>
      </el-table-column>-->
      <el-table-column label="冻结状态">
        <template slot-scope="scope">
          <el-button v-if="scope.row.userStatus == 0" size="mini" type="danger"
            :disabled="!$hasPerm('tenant:user_info:freeze')"
            @click="handleBlockingReason(true, scope.row.id)">冻结</el-button>
          <el-button v-if="scope.row.userStatus == '-1'" size="mini" type="danger" plain
            :disabled="!$hasPerm('tenant:user_info:unfreeze')"
            @click="handleBlocking(false, scope.row.id)">取消冻结</el-button>
        </template>
      </el-table-column>

      <el-table-column label="查询手机邮箱" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button v-if="$hasPerm('tenant:user_info:search_contact')" size="mini" type="primary" icon="el-icon-search"
            circle @click="handleSearch(scope.row.id)"></el-button>
        </template>
      </el-table-column>

      <el-table-column label="编辑" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(scope.row)"
          ></el-button> -->
          <el-button v-if="$hasPerm('tenant:user_info:cfd_config')" size="mini" type="primary"
            @click="handleCfd(scope.row)">
            CFD配置</el-button>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" v-if="
            scope.row.idNoStatus == 0 &&
            $hasPerm('tenant:user_info:open_manual_kyc')
          " @click="setPepo(scope.row)">
            开启人工实名</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged">
    </pagination>
    <update-dialog :val="userinfoDetail"></update-dialog>
    <el-dialog title="更新用户类型" :visible.sync="updateUserTypeDialogVisible" width="400px">
      <el-select v-model="newUserType" class="user-type-select">
        <el-option
          v-for="item in convertUserTypeOptions"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <div slot="footer">
        <el-button @click="closeUserTypeDialog">取消</el-button>
        <el-button type="primary" @click="handleUpdateUserType">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="searchDialogVisible" title="谷歌验证码" width="300px" @close="handleCloseGoogle">
      <el-form :model="form" ref="form" label-width="110px">
        <el-form-item label="谷歌验证码" prop="googleCode" :rules="[
          {
            required: true,
            message: '请输入谷歌验证码',
          },
        ]">
          <el-input v-model.trim="form.googleCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleCloseGoogle">取消</el-button>
        <el-button type="primary" @click="handleGoogle">确定</el-button>
      </div>
    </el-dialog>
    <showdialog :userId="userId"></showdialog>

    <el-dialog title="CFD配置" :visible.sync="CFDDialogVisible" width="700px">
      <el-form ref="CfdDetail" :model="CfdDetail" size="medium" label-width="160px" :rules="rules">
        <el-form-item label="CFD开关" prop="cfdSwitch">
          <el-switch v-model="CfdDetail.cfdSwitch"> </el-switch>
        </el-form-item>
        <el-form-item label="CFD市价滑点范围" prop="cfdSwitch">
          <el-input-number :step="0.006" controls-position="right" v-model="cfdOne"></el-input-number>
          ~
          <el-input-number :step="0.006" controls-position="right" v-model="cfdTwo"></el-input-number>
          <div>[0,0.1) 精度6</div>
        </el-form-item>
        <el-form-item v-model="CfdDetail.cfdSwitch" prop="cfdSwitch">
          <el-select v-model="symbolArr" placeholder="全部合约" clearable multiple>
            <el-option v-for="item in symbolList" :key="item.id" :label="item.symbol" :value="item.symbol"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSave('CfdDetail')">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="设置用户折扣" :visible.sync="discountRateDialogVisible" width="30%" center>
      <el-form label-width="120px" :rules="discountRateRules" :model="discountRateData" ref="discountRateForm">
        <el-form-item label="用户折扣 :" prop="discountRate">
          <el-input placeholder="请输入用户折扣" @input="handleInput" v-model="discountRateData.discountRate">
          </el-input>
          <div class="tip">
            <span>
              <i class="el-icon-warning-outline"></i>
              说明:请输入0到1之间的数字（包括0和1,最多两位小数）
            </span>
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="closeDiscountRate">取消</el-button>
        <el-button type="primary" @click="setDiscountRate">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑备注"
      :visible.sync="remarkDialogVisible"
      width="480px"
      @closed="resetRemarkForm"
    >
      <el-form label-width="80px">
        <el-form-item label="用户ID">
          <span>{{ remarkForm.userId }}</span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="remarkForm.remark"
            type="textarea"
            :rows="4"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="remarkDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="remarkSubmitting"
          @click="submitRemark"
        >保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'
import showdialog from '../showdialog'
import api from '../../api'
export default {
  name: 'UserList',

  data() {
    return {
      userTypes: {
        1: '模拟盘用户',
        2: '普通用户',
        3: '特殊账户',
      },
      convertUserTypeOptions: [
        { value: '1', label: '模拟盘用户' },
        { value: '3', label: '特殊账户' },
      ],
      // userTypes: {
      //   1: '无效用户',
      //   2: '普通用户',
      //   3: '初级股东',
      //   4: '中级股东',
      //   5: '高级股东'
      // },
      updateUserTypeDialogVisible: false,
      searchDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      userId: '',
      form: {
        googleCode: '',
      },
      CFDDialogVisible: false,
      CfdDetail: {
        cfdConfig: [0.0, 0.0],
        cfdSwitch: false,
        symbol: [],
        userId: '',
      },
      rules: {
        cfdConfig: {},
        cfdSwitch: false,
      },
      discountRateRules: {
        discountRate: [
          { required: true, message: '请输入用户折扣', trigger: 'blur' },
        ],
      },
      cfdOne: 0,
      cfdTwo: 0,
      symbolArr: [],
      symbolList: [],
      discountRateDialogVisible: false,

      discountRateData: { discountRate: '', userId: '' },
      errorMessage: '',
      remarkDialogVisible: false,
      remarkSubmitting: false,
      remarkForm: {
        userId: '',
        remark: '',
      },
    }
  },
  components: {
    Pagination,
    updateDialog,
    showdialog,
  },
  mounted() {
    api.getSymbolList().then((res) => {
      if (res.code == 0) {
        this.symbolList = res.data
      }
    })
  },
  methods: {
    ...mapActions('userOld', [
      'updateVolunteer',
      'updateBlocking',
      'cancelGoogle',
      'updateUserType',
      'updateDividendStatus',
      'updateMark',
      'telOrEmail',
      'updateCanLogin',
      'rebateRiskSwitch',
    ]),
    ...mapMutations('userOld', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
      'setAccountVisible',
      'setShowAccountInfo',
    ]),

    // timestampToTime(timestamp) {
    //     var date = new Date(timestamp-28800000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000 28800000为8小时时差
    //     var Y = date.getFullYear() + '-';
    //     var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):date.getMonth()+1) + '-';
    //     var D = (date.getDate()< 10 ? '0'+date.getDate():date.getDate())+ ' ';
    //     var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours())+ ':';
    //     var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()) + ':';
    //     var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
    //     return Y+M+D+h+m+s;
    // },
    formatVipTime(value) {
      if (!value) return '--'
      let d
      if (Array.isArray(value)) {
        d = new Date(value[0], value[1] - 1, value[2], value[3] || 0, value[4] || 0, value[5] || 0)
      } else {
        d = new Date(value)
      }
      if (Number.isNaN(d.getTime())) return '--'
      const p = (x) => String(x).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
    },
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
    handleUpdate(selected) {
      this.setUserinfoDetail(selected)
      this.setUserinfoDetailDialogVisible(true)
    },
    handleSearch(userId) {
      this.userId = userId
      this.searchDialogVisible = true
    },

    setnote(value) {
      this.setdialogVisible(true)
      this.setnodedetail(value)
    },
    handleBlocking(isSet, id) {
      const message = isSet ? '确认将此用户冻结吗？' : '确认取消冻结吗？'
      this.$confirm(message, '提示', {
        type: 'warning',
      }).then(() => {
        this.updateBlocking({
          id,
          status: isSet ? -1 : 0,
        }).then(() => {
          this.$message.success('设置成功！')
          this.$emit('refresh')
        })
      })
    },
    handleBlockingReason(isSet, id) {
      const message = '确认将此用户冻结吗？'
      this.$prompt('请输入冻结理由:', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.updateBlocking({
          id,
          status: isSet ? -1 : 0,
          content: value,
        }).then(() => {
          this.$message.success('操作成功！')
          this.$emit('refresh')
        })
      })
    },
    handleVolunteer(isSet, id) {
      const message = isSet
        ? '确认将此用户设为志愿者吗？'
        : '确认取消此志愿者吗？'
      this.$confirm(message, '提示', {
        type: 'warning',
      }).then(() => {
        this.updateVolunteer({
          id,
          status: isSet ? 1 : 0,
        }).then(() => {
          this.$message.success('设置成功！')
          this.$emit('refresh')
        })
      })
    },
    cancelGoo(id) {
      const message = '确定取消该用户谷歌认证吗'
      this.$confirm(message, '提示', {
        type: 'warning',
      }).then(() => {
        this.cancelGoogle({
          id: id,
        }).then(() => {
          this.$message.success('取消成功！')
          this.$emit('refresh')
        })
      })
    },
    handleUserType(user) {
      this.updateUserTypeDialogVisible = true
      this.newUserType = ''
      this.selectedForUserType = user
    },
    closeUserTypeDialog() {
      this.updateUserTypeDialogVisible = false
      this.newUserType = ''
      this.selectedForUserType = {}
    },
    handleUpdateUserType() {
      this.updateUserType({
        id: this.selectedForUserType.id,
        userType: this.newUserType,
      }).then(() => {
        this.closeUserTypeDialog()
        this.$message.success('更新成功！')
        this.$emit('refresh')
      })
    },
    handleUpdateDividendStatus(id, status) {
      this.$confirm('确认进行该操作吗？', '提示', {
        type: 'warning',
      }).then(() => {
        this.updateDividendStatus({ id, status }).then(() => {
          this.$message.success('更新成功！')
          this.$emit('refresh')
        })
      })
    },
    handleUpdateMarkStatus(userId, value, type) {
      this.$confirm('确认进行该操作吗？', '提示', {
        type: 'warning',
      }).then(() => {
        api[type]({ userId, [type]: value }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功！')
            this.$emit('refresh')
          }
        })
      })
    },
    handleUpdateCanLogin(id, canLogin) {
      this.$confirm("确认进行该操作吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.updateCanLogin({ userId: id, canLogin }).then(() => {
          this.$message.success("操作成功！");
          this.$emit("refresh");
        });
      });
    },
    handleUpdateRebateRiskSwitch(userId, rebateFlag) {
      this.$confirm('确认进行该操作吗？', '提示', {
        type: 'warning',
      }).then(() => {
        this.rebateRiskSwitch({ userId, rebateFlag }).then((res) => {
          if (res && res.code === 0) {
            this.$message.success('操作成功！')
            this.$emit('refresh')
          }
        })
      })
    },
    openRemarkDialog(row) {
      this.remarkForm = {
        userId: row.userId || row.id,
        remark: row.tenantAdminRemark || '',
      }
      this.remarkDialogVisible = true
    },
    submitRemark() {
      if (this.remarkSubmitting) return
      if (!this.remarkForm.userId) {
        this.$message.error('缺少用户ID，无法保存备注')
        return
      }
      this.remarkSubmitting = true
      api
        .updateTenantAdminRemark({
          userId: this.remarkForm.userId,
          remark: this.remarkForm.remark,
        })
        .then((res) => {
          if (res && res.code == 0) {
            this.$message.success('备注保存成功')
            this.remarkDialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error((res && res.msg) || '备注保存失败')
          }
        })
        .finally(() => {
          this.remarkSubmitting = false
        })
    },
    resetRemarkForm() {
      this.remarkForm = {
        userId: '',
        remark: '',
      }
    },
    handleCloseGoogle() {
      this.$refs.form.resetFields()
      this.searchDialogVisible = false
    },
    handleGoogle() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.telOrEmail({
            googleCode: this.form.googleCode,
            userId: this.userId,
          }).then((res) => {
            if (res.code == 0) {
              this.setShowAccountInfo({
                email: res.data.email,
                tel: res.data.tel,
              })
              this.setAccountVisible(true)
              this.searchDialogVisible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    handleCfd(row) {
      const obj = row.cfdConfig ? JSON.parse(row.cfdConfig) : {}
      const arr1 = obj ? Object.values(obj)[0] : []

      if (row.cfdConfig) {
        if (Object.keys(obj).includes('allSymbol')) {
          this.symbolArr = []
          this.CfdDetail.cfdSwitch = row.cfdSwitch
          this.CfdDetail.userId = row.userId
          this.cfdOne = arr1[0]
          this.cfdTwo = arr1[1]
        } else {
          this.cfdOne = arr1[0]
          this.cfdTwo = arr1[1]
          this.symbolArr = Object.keys(obj)
          this.CfdDetail.cfdSwitch = row.cfdSwitch
          this.CfdDetail.userId = row.userId
        }
      } else {
        this.symbolArr = []
        this.CfdDetail.cfdSwitch = row.cfdSwitch
        this.CfdDetail.userId = row.userId
        this.cfdOne = 0
        this.cfdTwo = 0
      }
      this.CFDDialogVisible = true
    },
    setPepo(row) {
      api.artificialKyc({ userId: row.id }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功！')
          this.$emit('refresh')
        }
      })
    },
    close() {
      this.$refs['CfdDetail'].resetFields()
      this.CFDDialogVisible = false
    },
    handleSave() {
      const that = this
      let obj = {}
      if (this.symbolArr.length != 0) {
        this.symbolArr.map((item) => {
          Object.assign(obj, { [item]: [this.cfdOne, this.cfdTwo] })
          return obj
        })
        this.CfdDetail.cfdConfig = obj
      } else {
        this.CfdDetail.cfdConfig = { allSymbol: [this.cfdOne, this.cfdTwo] }
      }

      delete this.CfdDetail.symbol
      api
        .updateCfd({
          ...this.CfdDetail,
          cfdConfig: JSON.stringify(this.CfdDetail.cfdConfig),
        })
        .then((res) => {
          if (res.code == 0) {
            this.$emit('refresh')
            this.$message.success('配置成功')
            this.close()
          }
        })
    },
    openDiscountRate(row) {
      this.discountRateData.discountRate = row.discountRate
      this.discountRateData.userId = row.userId
      this.discountRateDialogVisible = true
    },
    setDiscountRate() {
      api
        .fetchDiscountRate({
          ...this.discountRateData,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功！')
            this.discountRateDialogVisible = false

            this.$emit('refresh')
          }
        })
    },
    closeDiscountRate() {
      this.discountRateDialogVisible = false
      this.$refs['discountRate'].resetFields()
    },

    handleInput(value) {
      // 清除之前的错误信息
      this.errorMessage = ''

      // 去除前后空格
      const trimmedValue = value.trim()

      // 检查是否包含汉字
      if (/[\u4e00-\u9fa5]/.test(trimmedValue)) {
        this.errorMessage = '不能输入汉字'
        this.discountRateData.discountRate =
          this.discountRateData.discountRate.slice(0, -1) // 回退一个字符
        return
      }

      // 尝试将输入转换为浮点数
      let num = trimmedValue

      // 检查是否为有效数字
      if (isNaN(num)) {
        this.errorMessage = '请输入有效的数字'
        this.discountRateData.discountRate =
          this.discountRateData.discountRate.slice(0, -1) // 回退一个字符
        return
      }

      // 检查数字是否在0到1之间（包括0和1）
      if (num < 0 || num > 1) {
        this.errorMessage = '请输入0到1之间的数字'
        this.discountRateData.discountRate =
          this.discountRateData.discountRate.slice(0, -1) // 回退一个字符
        return
      }

      // 检查输入的小数位数是否超过两位（虽然toFixed已经处理了，但这里再验证一下）
      if (num.includes('.') && num.split('.')[1].length > 2) {
        // 这种情况实际上不会发生，因为toFixed已经确保了两位小数

        // 但为了代码的完整性，我们还是保留这个检查
        this.errorMessage = '只能输入两位小数'
        this.discountRateData.discountRate = num.slice(0, -1) // 理论上这里不会执行，但为了安全起见还是加上
      } else {
        // 更新输入框的值
        this.discountRateData.discountRate = num
      }

      // 如果最终没有错误，但输入框为空（理论上不会，因为上面已经处理了），则重置为''（其实不需要，因为v-model已经处理了）
      // 但为了代码的完整性，我们还是保留这个检查（实际上是多余的）
      if (!this.errorMessage && !this.discountRateData.discountRate.trim()) {
        this.discountRateData.discountRate = ''
      }
    },
  },
  computed: {
    ...mapGetters('userOld', ['userList']),
    ...mapState('userOld', [
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
    ]),
  },
}
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}

.red {
  color: red;
  font-weight: bold;
}

.discountRate {
  color: rgb(0, 81, 255);

  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
}

.remark-edit {
  display: inline-block;
  max-width: 160px;
  overflow: hidden;
  color: #409eff;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
}
</style>
